import React from 'react';
import { m } from 'framer-motion';

export const SlideIn = ({ direction, children }) => (
  <m.div
    initial={{
      opacity: 0,
      x: direction !== 'none' ? (direction === 'left' ? 50 : -50) : 0,
    }}
    whileInView={{
      opacity: 1,
      x: 0, // Slide in to its original position
      transition: {
        duration: 1, // Animation duration
      },
    }}
    viewport={{ once: true }}
  >
    {children}
  </m.div>
);
